/**
 * 指定した会計期間の NFT 取得日時一覧を取得する。
 * 損益計算で再利用しやすいように NFT ID をキーにした Map で返す。
 */
import { eq } from 'drizzle-orm'
import { nftAcquiredTimestampTable } from '../schema'
import type { DatabaseWithTransaction } from '../types'

type SelectNftAcquiredTimestampsParameters = {
  readonly database: DatabaseWithTransaction
  readonly accountingPeriodId: number
}

/**
 * 会計期間末の NFT 取得日時を取得する。
 * @param params 取得条件
 * @returns NFT ID をキーにした取得日時 Map
 */
export const selectNftAcquiredTimestamps = async ({
  database: { database },
  accountingPeriodId,
}: SelectNftAcquiredTimestampsParameters): Promise<Map<string, number>> => {
  const rows = await database
    .select()
    .from(nftAcquiredTimestampTable)
    .where(eq(nftAcquiredTimestampTable.accountingPeriodId, accountingPeriodId))

  return new Map(
    rows.map((row) => [row.nftId, row.timestamp.getTime()] as const),
  )
}
